<template>
 <div>
  <div style="min-height:150px">
    <p v-if="!isLoading && todo === undefined" style="margin-top:30px;text-align:center">
      お買い物リストは見つかりませんでした。<br>
      <router-link :to="{name: 'EditTodo'}" class="pink--text">お買い物リストを作成してみましょう！</router-link>
    </p>
    <div v-if="todo">
      <h1 style="font-size:16pt;color:#333;margin-bottom:16px;">
        {{todo.metas.title}}
      </h1>
      <draggable tag="ul" id="todolist" :options="{handle: '.item-handle'}">
          <li v-for="(t, index) in todos" :key=t.key :id=t.key>
          <v-card
            flat
            class="todoContent"
            v-show="t.isVisible"
            style="border-bottom: solid 1px #ddd"
            tile
          >
            <textarea
              v-show="t.isEditMode"
              v-model="todos[index].t"
              outlined
              rows="1"
              style="width:100%;padding:8px 10px;resize: none;overflow-y:visible;"
              @keyup="onInputText(t.key)"
              @focus="onFocus(t.key)"
              @focusout="onFocusout(t.key)"
              :ref="`${t.key}`"
            ></textarea>
            <v-list v-show="!t.isEditMode" v-bind:class="{'isDone': t.isDone}">
              <v-list-item>
                <v-list-item-icon class="item-handle">
                  <v-icon>mdi-drag</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    @click="onReEdit(t.key)"
                  >
                    {{t.t}}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon style="padding:0;margin:0">
                  <v-checkbox
                    style="margin-top:7px;"
                    v-model="t.isDone"
                    @change="toggleStatus(t.key)"
                    color="pink"
                  ></v-checkbox>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
          </li>
        </draggable>
        <ul>
          <li v-for="(t, index) in todoEdit" :key=t.key :id=t.key>
            <v-card
              flat
              class="todoContent"
              style="border-bottom: solid 1px #ddd"
              tile
            >
              <textarea
                v-model="todoEdit[index].t"
                outlined
                rows="1"
                style="width:100%;padding:8px 10px;resize: none;overflow-y:visible;"
                @keyup="onInputText(t.key)"
                @focus="onFocus(t.key)"
                @focusout="onFocusout(t.key)"
                :placeholder="placeHolder(index)"
                :ref="`${t.key}`"
              ></textarea>
            </v-card>
          </li>
        </ul>
        <div style="height:450px;"></div>
        <v-card flat style="position:fixed; bottom:0;left:0;width:100%;border-top:1px solid #ccc;">
          <v-row style="padding:10px;">
            <v-spacer></v-spacer>
              <v-btn outlined color="pink" large
                @click="onURLCopy"
              >
                <v-icon>mdi-clipboard-multiple-outline</v-icon>
                <span style="font-size:110%;">シェアURLコピー</span>
              </v-btn>
              <v-btn color="pink" large dark style="margin-left:10px;"
                @click="onEdit"
              >
                <v-icon>mdi-pencil-plus</v-icon>
                <span style="font-size:120%;">追加</span>
              </v-btn>
            <v-spacer></v-spacer>
          </v-row>
        </v-card>
      </div>
  </div>
  <progress-circle v-show="isLoading"></progress-circle>
  </div>
</template>

<script>
import todoManager from '@/assets/js/todoManager.js'
import firebase from 'firebase/app'
import draggable from 'vuedraggable'
import ProgressCircle from '../components/common/ProgressCircle'


import 'firebase/firestore'
import { db } from '@/main'

// @ is an alias to /src
export default {
  name: 'TodoView',
  data () {
    return {
      id: undefined,
      todo: undefined,
      tab: undefined,
      pushTitle: '',
      lastUpdateInfoMessage: '',
      imax: 2,
      iNokori: 2,
      todoEdit: [],
      iUsed: 0,
      isLoading: true,
      isInitDone: false,
      focus: {
        key: '',
        t: '',
        isInputed: undefined
      }
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.user.isLogin
    },
    uid () {
      return this.$store.state.user.uid
    },
    displayName () {
      return this.$store.state.user.displayName
    },
    todos () {
      return this.todo.list
    },
    displayNames () {
      return this.todo.metas.displayNames
    }
  },
  components: {
    draggable,
    ProgressCircle
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      // 匿名認証
      this.anonymousLogin()

      // Todoリストのリッスン
      this.id = this.$route.params.id
      db.collection('todos').doc(this.id).onSnapshot((doc) => {
        this.isLoading = false
        let obj = doc.data()
        obj.list = todoManager.obj2list(obj.todos)
        
        // 初期化未実施の場合、スナップショットをセットする
        if (!this.isInitDone) this.todo = obj

        //todoリストのメンバーに追加
        this.addListMember()
        // 更新された場合だけやりたい処理
        if (obj.updateInfo) {
          if (this.lastUpdateInfoMessage !== obj.updateInfo.message) {
            //messageの表示
            let uid = obj.updateInfo.uid
            let messageObj = {
              text: obj.updateInfo.message
            }
            if (uid !== this.uid) {
              let user = this.getDisplayNameByUid(obj.updateInfo.uid)
              let displayName = user.displayName
              messageObj.type = 'warning'
              messageObj.title = `${displayName}さんが更新しました。`
              
              // 別の人が更新したときだけ反映
              this.todo = obj
            } 
            if (this.isInitDone) this.$emit('onMessage', messageObj)
            this.lastUpdateInfoMessage = obj.updateInfo.message
          }
        } else {
          // 動作しないパタン。念のため
          this.todo = obj
        }
        this.isInitDone = true
      })

      // 入力エリアの初期化
      this.initEditArea()
    },
    placeHolder (index) {
      if (index === 0) {
        return '追加する場合はこちらに入力'
      } else if (index === 1) {
        return '改行で決定します'
      }
    },
    toggleStatus (key) {
      let res = this.getTodoIndexByKey(key)
      let index = res.index
      let list = res.list
      let m = ''
      if (list[index].isDone) {
        m = '完了にしました'
      } else {
        m = '未完了に戻しました'
      }
      let updateInfo = {
        message: `${list[index].t}を${m}`,
        uid: this.uid
      }
      this.updateTodo(key, updateInfo)
    },
    updateTodo (key, updateInfo) {
      let res = this.getTodoIndexByKey(key)
      let index = res.index
      let list = res.list

      let obj = {}
      obj.todos = {}
      obj.todos[key] = list[index]
      obj.updateInfo = updateInfo
      db.collection('todos').doc(this.id).set(obj, {merge: true})
    },
    edit2list (key, index, ref) {
      if (ref) this.$refs[ref][0].focus()
      let objList = this.todoEdit.splice(index, 1)
      let obj = objList[0]
      // obj.displayName = this.todos.length
      let updateObj = {}
      updateObj.todos = {}
      updateObj.todos[key] = obj
      updateObj.updateInfo = {
        message: `${obj.t}を追加しました`,
        uid: this.uid
      }

      this.todos.push(obj)
      
      if (ref) {
        // フォーカスを次の行へ
        setTimeout(
          function() {
            this.$refs[ref][0].focus()
          }.bind(this),
          100
        );
      }
      db.collection('todos').doc(this.id).set(updateObj, {merge: true})      
    },
    addListMember () {
      if (this.uid && this.todo) {
        if (!this.todo.members.find(m => m === this.uid)) {
          // uidを追加する
          db.collection('todos').doc(this.id).update({
            'members': firebase.firestore.FieldValue.arrayUnion(this.uid),
            'metas.displayNames': firebase.firestore.FieldValue.arrayUnion({
              uid: this.uid,
              displayName: this.displayName
            })
          })
        }
      }
    },
    async anonymousLogin () {
      // 匿名認証
      if (!this.isLogin) await this.$store.dispatch('user/loginAnonymous')
      // todoリストのメンバーに追加
      this.addListMember()
    },
    onInputText (key) {
      let res = this.getTodoIndexByKey(key)
      let index = res.index
      let list = res.list

      let isEdit2list = false
      if (list[index].t.indexOf('\n') >= 0) {
        // 改行を検知

        // 改行を消す
        let text = list[index].t.replace(/\n/g, '')
        // 改行のみしか入力がなければ何もしない
        if (text === '') return

        let obj = list[index]
        // 入力済に更新
        obj.isEditMode = false

        // 未入力だった場合は、editエリアからリストへ追加する
        if (!obj.isInputed) {
          isEdit2list = true
        }
        obj.t = text
        obj.isInputed = true
        this.$set(list, index, obj)
        
        // 次の行のref取得
        let nextTodo = this.getNextTodoByKey(key)
        let refName = nextTodo.key

        if (isEdit2list) {
          this.edit2list(key, index, refName)
        }

        if (!this.isNokoriAru()) {
          this.addListObj()
        }
      }
    },
    onFocus (key) {
      let res = this.getTodoIndexByKey(key)
      let index = res.index
      let list = res.list
      let focusIndex = index
      if (list[index].t.length <= 0) {
        // 対象が未入力の場合
        // indexより前に未入力のカラムがないかチェックする
        for (let i = 0; i <= index; i ++) {
          if (list[i].isVisible && list[i].t.length === 0) {
            let refName = list[i].key
            this.$refs[refName][0].focus()
            focusIndex = i
            break
          }
        }
      }

      // focusしたデータを記憶しておく
      this.focus.key = list[focusIndex].key
      this.focus.t = list[focusIndex].t
      this.focus.isInputed = list[focusIndex].isInputed // True：更新、False：新規登録
    },
    onFocusout (key) {
      let res = this.getTodoIndexByKey(key)
      let index = res.index
      let list = res.list
      let isEdit2list = false
      if (!list[index]) return // edit2list直後だと取得に失敗する
      if (list[index].isInputed) { // テキストの更新時
        if (list[index].t.length > 0) {
          list[index].isEditMode = false
        } else {
          list[index].isVisible = false
        }

        if (this.focus.isInputed && this.focus.key === list[index].key && this.focus.t !== list[index].t) {
          // 更新かつ内容が変わっている場合
          let updateInfo = {
            uid: this.uid,
            message: `「${this.focus.t}」を「${list[index].t}」に更新しました。`
          }
          this.updateTodo(key, updateInfo)
        }
      } else {
        if (list[index].t.length > 0) { // テキストの新規登録時
          list[index].isInputed = true
          list[index].isEditMode = false
          isEdit2list = true
        }
      }

      if (isEdit2list) {
        // console.log('done!!')
        this.edit2list(key, index, undefined)
      }
    },
    onReEdit (key) {
      let res = this.getTodoIndexByKey(key)
      let index = res.index
      let list = res.list

      list[index].isEditMode = true
      let refName = list[index].key
      // console.log(this.$refs[refName][0])
      setTimeout(
        function() {
          this.$refs[refName][0].focus()
        }.bind(this),
        100
      );
    },
    onURLCopy () {
      let url = `https://simpletodo-f1a7d.web.app/t/${this.id}`
      this.execCopy(url)
      this.$emit('onMessage', {
          title: 'URLをコピーしました。',
          text: 'パートナーにリストをシェアしましょう！'
        })
    },
    execCopy (string) {
      // 空div 生成
      var tmp = document.createElement("div");
      // 選択用のタグ生成
      var pre = document.createElement('pre');

      // 親要素のCSSで user-select: none だとコピーできないので書き換える
      pre.style.webkitUserSelect = 'auto';
      pre.style.userSelect = 'auto';

      tmp.appendChild(pre).textContent = string;

      // 要素を画面外へ
      var s = tmp.style;
      s.position = 'fixed';
      s.right = '200%';

      // body に追加
      document.body.appendChild(tmp);
      // 要素を選択
      document.getSelection().selectAllChildren(tmp);

      // クリップボードにコピー
      var result = document.execCommand("copy");

      // 要素削除
      document.body.removeChild(tmp);

      return result;
    },
    onPush() {
      if (this.pushTitle.length === 0) {
        this.$emit('onMessage', {
          text: '追加したい内容を入力してください'
        })
        return
      }

      let date = new Date()
      let time = date.getTime()
      let obj = {
        t: this.pushTitle,
        isEditMode: false, // trueでテキスト編集モード
        isInputed: true, // 最初に入力されたらTrue
        isVisible: true,
        isDone: false,
        uid: this.uid,
        key: `col_${time}`
      }

      db.collection('todos').doc(this.id).update({
        'todos': firebase.firestore.FieldValue.arrayUnion(obj)
      })
      this.pushTitle = ''
      this.$emit('onMessage', {
        text: 'Listに追加しました'
      })
    },
    initEditArea () {
      for (let i = 0; i < this.imax; i++) {
        this.addListObj()
      }
    },
    isNokoriAru () {
      let nokori = 0
      for (let i = 0; i < this.todoEdit.length; i++) {
        if (this.todoEdit[i].t === '') {
          nokori = nokori + 1
          if (nokori >= this.iNokori) {
            return true
          }
        }
      }
      return false
    },
    addListObj () {
      let now = new Date()
      let time = now.getTime()
      this.todoEdit.push({
        t: '',
        isEditMode: true, // trueでテキスト編集モード
        isInputed: false, // 最初に入力されたらTrue
        isVisible: true,
        isDone: false,
        uid: this.uid,
        key: `col_${time}_${this.iUsed}`
      })
      this.iUsed = this.iUsed + 1
    },
    getTodoIndexByKey (key) {
      let index = this.todos.findIndex(t => t.key === key)
      if (index >= 0) {
        return {list: this.todos, index: index}
      }

      index = this.todoEdit.findIndex(t => t.key === key)
      return {list: this.todoEdit, index: index}
    },
    getNextTodoByKey (key) {
      let index = this.todos.findIndex(t => t.key === key)
      if (index >= 0) {
        return this.todos[index + 1]
      }

      index = this.todoEdit.findIndex(t => t.key === key)
      return this.todoEdit[index + 1]
    },
    onEdit () {
      let obj = this.todoEdit[0]
      let key = obj.key
      this.$refs[key][0].focus()
    },
    getDisplayNameByUid (uid) {
      return this.displayNames.find(m => m.uid === uid)
    }
  },
  head: {
    meta: [
      {name: 'robots', content: 'noindex'}
    ]
  }
}
</script>
<style scoped>
  .isDone {
    background-color:#eee;
  }
  .row {
    margin: 0 !important;
  }
  .v-btn--outlined {
    background: #fff;
  }
  .todoContent >>> .v-list {
    padding: 0 !important;
  }
  .todoContent >>> .v-list-item {
    padding: 0 !important;
    height: 48px;
  }
  .todoContent >>> .v-list-item__content {
    padding: 8px 0 !important;
  }
  .todoContent >>> .v-list-item__icon {
    margin-right: 16px;
    margin-top: 12px;
  }
</style>
